import { Language } from '../types';

export const languages = {
  zh: {
    welcome: {
      title: 'AI 与 Web3 认知测评',
      subtitle: '只需5分钟！就能全面评估您对 AI 和 Web3 的认知程度',
      startButton: '开始评估',
      categorySelection: '选择评估领域',
      categoryAI: 'AI',
      categoryWeb3: 'Web3',
      categoryBoth: 'AI + Web3 综合评估'
    },
    assessment: {
      questionCount: '问题',
      of: '/',
    },
    results: {
      title: '您的评估结果',
      overallScore: '总分',
      retakeButton: '重新测试',
      aiKnowledge: 'AI 知识水平',
      web3Knowledge: 'Web3 知识水平',
      levelTitle: '专业评价',
      suggestionsTitle: '提升建议',
      contactTitle: '获取完整报告',
      contactInfo: '联系我们获取个性化提升方案',
      wechatInfo: '微信：AIGC_creativity_DAO',
      downloadReport: '下载报告概要'
    },
  },
  en: {
    welcome: {
      title: 'AI & Web3 Knowledge Assessment',
      subtitle: 'Just 5 minutes! You can comprehensively assess your understanding of AI and Web3.',
      startButton: 'Start Assessment',
      categorySelection: 'Select Assessment Category',
      categoryAI: 'AI',
      categoryWeb3: 'Web3',
      categoryBoth: 'AI + Web3 Combined'
    },
    assessment: {
      questionCount: 'Question',
      of: 'of',
    },
    results: {
      title: 'Your Results',
      overallScore: 'Overall Score',
      retakeButton: 'Retake Assessment',
      aiKnowledge: 'AI Knowledge',
      web3Knowledge: 'Web3 Knowledge',
      levelTitle: 'Professional Evaluation',
      suggestionsTitle: 'Improvement Suggestions',
      contactTitle: 'Get Full Report',
      contactInfo: 'Contact us for a complete assessment report and personalized improvement plan',
      wechatInfo: 'WeChat: AIGC_creativity_DAO',
      downloadReport: 'Download Summary Report'
    },
  },
} as const;